
import { DashboardPage } from "../../components/layout/dashboardPage";
import { Notifications } from "../../components/dashboard/notifications";
import { Col } from "../../style/base.style";
import { Colors } from "../../style/colors";

export const DashboardNotififications:React.FC = () => {

  
    return (
      <DashboardPage title="notifications">
        <Col $width="100%" $justifyContent="flex-start" $alignItems="flex-start" $backgroundColor={Colors.whiteBackground} $padding="20px" $border={`1px solid ${Colors.fieldBorder}`} $borderRadius={10}>
         <Notifications/>
        </Col>
        
          
      </DashboardPage>
        
    )
}